import ApiService from "@/common/api.service";
import { FETCH_ADMIN_OPTIONS } from "./actions.type";
import {
    FETCH_START_ADMIN_OPTIONS,
    FETCH_END_ADMIN_OPTIONS
} from "./mutations.type";

const state = {
    adminOptions: [],
    isLoading: true
};

const getters = {
    adminOptions(state) {
        return state.adminOptions;
    },
    isLoadings(state) {
        return state.isLoading;
    },
    getAdminOption: (state) => (key) => {
        return state.adminOptions.find((option) => option.option_key == key);
    }
};

const actions = {
    [FETCH_ADMIN_OPTIONS]({ commit }) {
        commit(FETCH_START_ADMIN_OPTIONS);
        return ApiService.get("/get-socialLinks")
            .then(({ data }) => {
                commit(FETCH_END_ADMIN_OPTIONS, data);
            })
            .catch((error) => {
                throw new Error(error);
            });
    }
};

const mutations = {
    [FETCH_START_ADMIN_OPTIONS](state) {
        state.isLoading = true;
    },
    [FETCH_END_ADMIN_OPTIONS](state, { links }) {
        state.adminOptions = links;
        state.isLoading = false;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
